import { isObjectChangedAfter } from "../lib";

export const scansByEidFilteredComparator = eids => scan =>
  eids.includes(scan.EID);

export const checkpointsChangedAfterScanComparator = checkpoints => scan =>
  isObjectChangedAfter(scan, checkpoints[0]);
